export default {
  getLogins: () => $nuxt.$axios.get($nuxt.$api.host + '/logins'),
  switchTo: (data) => $nuxt.$axios.post($nuxt.$api.host + '/me/switch-account', data),
  createImpersonationAccount: (account_uuid, data) => $nuxt.$axios.post($nuxt.$api.host + '/impersonated-login/' + account_uuid, data),
};
